import { InvestigationStatusesTableActions } from "routes/investigation_status/components/InvestigationStatusesTableActions";

export const getInvestigationStatusesTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: "Description",
      id: "Description",
      accessorKey: "description",
    },
    {
      header: null,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => (
        <InvestigationStatusesTableActions original={row.original} />
      ),
    },
  ];
};

export const getInvestigationStatusesTableFilters = () => {
  return [];
};
